(() => {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  const root = window.Shopify?.routes?.root || '/';
  const body = drawer.querySelector('.drawer-body');
  const status = drawer.querySelector('[data-drawer-status]');
  let pending = false;
  let opener;
  function message(text) { status.textContent = text; }
  function busy(value) {
    pending = value;
    body.setAttribute('aria-busy', String(value));
    body.querySelectorAll('input, button').forEach(el => { el.disabled = value; });
  }
  async function refresh() {
    const response = await fetch(`${root}cart?section_id=cart-drawer`, {cache: 'no-store'});
    if (!response.ok) throw new Error('Your cart could not be loaded. Please use View full cart below.');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = html.querySelector('[data-cart-drawer-content]');
    if (!content) throw new Error('Your cart could not be loaded. Please use View full cart below.');
    body.replaceChildren(content);
    const count = Number(content.querySelector('[data-drawer-count]')?.dataset.drawerCount || 0);
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = count ? `(${count})` : ''; });
  }
  async function open(trigger) {
    if (pending) return;
    opener = trigger || document.activeElement;
    document.getElementById('quick-shop')?.close();
    if (!drawer.open) drawer.showModal();
    document.documentElement.classList.add('cart-drawer-open');
    drawer.querySelector('[data-drawer-fallback]').hidden = true;
    message('Loading your cart…');
    busy(true);
    try { await refresh(); message(''); }
    catch (error) { message(error.message); drawer.querySelector('[data-drawer-fallback]').hidden = false; }
    finally { busy(false); }
  }
  drawer.querySelector('[data-drawer-close]').addEventListener('click', () => drawer.close());
  drawer.addEventListener('close', () => {
    document.documentElement.classList.remove('cart-drawer-open');
    if (opener?.isConnected && !opener.closest('dialog:not([open])')) opener.focus();
  });
  drawer.addEventListener('click', event => {
    if (event.target === drawer) {
      const rect = drawer.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) drawer.close();
    }
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('.cart-link');
    if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault(); open(trigger);
  });
  document.addEventListener('tcg:cart-added', () => open());
  async function change(key, quantity, focusId) {
    if (pending || !Number.isInteger(quantity) || quantity < 0) return;
    busy(true); message('Updating your cart…');
    let updateError;
    try {
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: key, quantity})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to update this item.');
    } catch (error) { updateError = error instanceof TypeError ? 'Could not confirm the update. Check your cart before trying again.' : error.message; }
    try { await refresh(); message(updateError || 'Cart updated.'); }
    catch (error) { message(updateError || error.message); drawer.querySelector('[data-drawer-fallback]').hidden = false; }
    finally {
      busy(false);
      const focusTarget = focusId && body.querySelector(`#${CSS.escape(focusId)}`);
      (focusTarget || drawer.querySelector('[data-drawer-close]')).focus();
    }
  }
  drawer.addEventListener('change', event => {
    const input = event.target.closest('[data-drawer-quantity]');
    if (input && input.reportValidity()) change(input.dataset.key, Number(input.value), input.id);
  });
  drawer.addEventListener('click', event => {
    const remove = event.target.closest('[data-drawer-remove]');
    if (remove) change(remove.dataset.key, 0);
  });
})();
